function initTabs() {
	$('.tabs__btn').on('click', (e) => {
		let thisTabNum = $(e.currentTarget).data('tab');

		$(e.currentTarget).blur();

		$(e.currentTarget).siblings('.tabs__btn').removeClass('is-current');
		$(e.currentTarget).addClass('is-current');

		$(e.currentTarget).closest('.tabs__nav').siblings('.tabs__container').find('.tabs__tab').addClass('is-hidden');
		$(e.currentTarget).closest('.tabs__nav').siblings('.tabs__container').find(`.tabs__tab[data-tab="${thisTabNum}"]`).removeClass('is-hidden');

		$(document).trigger('tabs.tabChange');
	});
}

initTabs();

$('body').on('click', (e) => {
	if ($(e.target).closest('.progress-select').length) {
		$('.progress-select').not($(e.target).closest('.progress-select')).removeClass('is-opened');
		$(e.target).closest('.progress-select').toggleClass('is-opened');
	} else {
		$('.progress-select').removeClass('is-opened');
	}
});

$('.progress-select__item').on('click', (e) => {
	let $item = $(e.currentTarget);
	let $container = $item.closest('.progress-select');
	let data1;
	let data2;

	if (!$container.hasClass('progress-select--month')) {
		data1 = $item.data('select');

		$('.progress-select--month').addClass('is-hidden');
		$(`.progress-select--month[data-year="${data1}"]`).removeClass('is-hidden');
	}

	$container.find('.progress-select__item').removeClass('is-current');
	$item.addClass('is-current');
	$container.find('.progress-select__selected').text($item.text());

	data1 = $('.progress-select--year .progress-select__item.is-current').data('select');
	data2 = $('.progress-select--month:not(.is-hidden) .progress-select__item.is-current').data('select');

	$('.selectblock__tab').addClass('is-hidden');
	$(`.selectblock__tab[data-tab="${data1}-${data2}"]`).removeClass('is-hidden');

	$(document).trigger('selectblock.tabChange');
});
